<template>
  <div class="article-video" :style="{ 'background-image': backgroundImage }">
    <div class="play-box">
      <div class="play"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ArticleVideo",
  props: {
    videoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      backgroundImage: ""
    };
  },
  mounted() {
    this.backgroundImage = `url(${this.videoList[0].cover})`;
  }
};
</script>
<style lang="less" scoped>
.article-video {
  position: relative;
  width: 400px;
  height: 220px;
  box-sizing: content-box;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 14px 0;
  background-clip: content-box;
  .play-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(69, 81, 72, 0.5);
    width: 50px;
    height: 50px;
    border-radius: 30px;
    .play {
      position: absolute;
      top: 50%;
      left: 48%;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 14px;
      border-color: transparent transparent #fff transparent;
      transform: rotate(90deg) scaleY(1.3) translate(-50%, -0%);
    }
  }
}
</style>
